/**
 * Resolves vm_args for task runtime settings.
 * suggestedVmArgs is placeholder-only — never returned as the value.
 */
export function resolveVmArgs(opts: {
  suggestedVmArgs?: string
  isMuleVersionUpgrade?: boolean
  matchingIndexVmArgs?: string
}): string {
  if (opts.isMuleVersionUpgrade) return ''
  if (opts.suggestedVmArgs) return ''
  if (opts.matchingIndexVmArgs) return opts.matchingIndexVmArgs
  return ''
}
